import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExpenseType } from 'app/core/model/expense/expense-type.model';
import { MainExpenseType } from 'app/core/model/expense/main-expense-type.model';
import { ExpenseService } from 'app/modules/expense/service/expense.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-expense-type-form',
  templateUrl: './expense-type-form.component.html',
  styleUrl: './expense-type-form.component.scss'
})
export class ExpenseTypeFormComponent implements OnInit {

  // #region Variables
  @Input() expenseTypeData: ExpenseType;
  @Input() operationNumber: number;

  @Output() refreshExpenseTypeList = new EventEmitter<boolean>();
  @Output() closeForm = new EventEmitter<boolean>();
  mainExpenseTypeDropdown: MainExpenseType[] = [];
  form: FormGroup;
  disableSave: boolean = false;
  expenseTypeList: ExpenseType[] = [];
  iconOptions: any;

  constructor(
    private formBuilder: FormBuilder,
    private expenseService: ExpenseService,
    private toastrService: ToastrService
  ){
    this.iconOptions = [
      { name: 'icon-uncategorised', value: 'icon-uncategorised' },
      { name: 'icon-commute', value: 'icon-commute' },
      { name: 'icon-travel', value: 'icon-travel' },
      { name: 'icon-food', value: 'icon-food' },
      { name: 'icon-entertainment', value: 'icon-entertainment' },
      { name: 'icon-accomodation', value: 'icon-accomodation' },
      { name: 'icon-fuel', value: 'icon-fuel' },
      { name: 'icon-meter', value: 'icon-meter' },
      { name: 'icon-office', value: 'icon-office' },
      { name: 'icon-material', value: 'icon-material' },
      { name: 'icon-labour', value:  'icon-labour' },
      { name: 'icon-time-based', value: 'icon-time-based' },
      { name: 'fa fa-hospital-o', value: 'fa fa-hospital-o' },
      { name: 'fa fa-user', value: 'fa fa-user' },
      { name: 'fa fa-cubes', value: 'fa fa-cubes'},
    ];
  }

  ngOnInit(){
    this.loadExpenseTypeList();
    this.setUpForm();
    if(this.operationNumber == 0){
      this.setEdit(this.expenseTypeData.id);
    }
    this.bindDropdown();
  }

  bindDropdown(){
    this.expenseService.getMainExpenseType().subscribe((x)=>{
      const filteredType = x.filter(item => item.name !== 'SYSTEM');
      this.mainExpenseTypeDropdown = filteredType;
    });
  };

  loadExpenseTypeList(event?) {
    this.expenseService.getAllExpenseTypeList().subscribe((x) => {
      this.expenseTypeList = x;
    });
  }

  setUpForm(){
    this.form = this.formBuilder.group({
      id: [0],
      name: ['', Validators.required],
      type: [''],
      description: ['', [Validators.required]],
      icon: ['', [Validators.required]],
      organization:[1],
    });
  }

  setEdit(id: number) {
    this.form.patchValue({
      id:id,
      name:this.expenseTypeData.name,
      description:this.expenseTypeData.description,
      type:this.expenseTypeData.main_expense_type,
      icon:this.expenseTypeData.icon,
      organization:1,
    })
  }

  saveExpenseType(){
    this.disableSave=true
    this.form.markAllAsTouched();
    if(!this.form.invalid){
      let isNameExists = this.expenseTypeList.some((item)=>item.name.toLocaleLowerCase()===this.form.value.name.toLocaleLowerCase());
      if (this.operationNumber == 0){
        isNameExists = false
      }
      if (isNameExists){
        this.disableSave = false;
        this.toastrService.warning(`Expense type with name '${this.form.value.name}' already exists!`);
      }else{
        this.expenseService.saveExpenseType(this.form.value).subscribe(
          (x)=>{
            this.disableSave=false;
            this.toastrService.success("Record Saved Successfully","Success");
            this.refreshExpenseTypeList.emit(true);
            this.setUpForm();
            this.exitForm();
          }
        )
      }
    }else{
      this.disableSave=false;
      // this.toasterService.warning("Name and Description can not be Empty!")
    }
  }

  exitForm(){
    this.closeForm.emit(true);
  }
}
